<aa-popin-v3 [isShown]="isShown"
             (clickOutside)="onClickOutside()"
             [onClose]="onClosePopin"
             [width]="52"
             [backPic]="'forms'"
             [hasCancelButton]="true">
    <div class="title"> {{ 'CMDB.TAGS.CREATE.TITLE' | translate}}</div>
    <div class="popin-content-body">
        <form [formGroup]="formGroup">
            <div class="select-color">
                <div class="zone-color">
                    <fieldset>
                        <legend>{{ 'CMDB.TAGS.CREATE.COLOR' | translate}}</legend>
                        <div class="cmdb-tag-select-color">
                            <aa-color-palette (colorSelected)="changeFontColor($event)"
                                              [selectedColor]="defaultFgColor">
                            </aa-color-palette>
                            <aa-input-color2 name="fgColor"
                                            label="{{ 'CMDB.TAGS.CREATE.COLOR' | translate}}"
                                            [formControlName]="FgColorField">
                            </aa-input-color2>
                        </div>
                    </fieldset>
                </div>
                <div class="zone-color">
                    <fieldset>
                        <legend>{{ 'CMDB.TAGS.CREATE.BACKGROUNDCOLOR' | translate}}</legend>
                        <div class="cmdb-tag-select-color">
                            <aa-color-palette (colorSelected)="changeBackgroundColor($event)"
                                              [selectedColor]="defaultBgColor">
                            </aa-color-palette>
                            <aa-input-color2 name="bgColor"
                                            label="{{ 'CMDB.TAGS.CREATE.BACKGROUNDCOLOR' | translate}}"
                                            [formControlName]="BgColorField">
                            </aa-input-color2>
                        </div>
                    </fieldset>
                </div>
            </div>
            <fieldset>
                <legend>Tag&nbsp;&nbsp;&nbsp;<span class="chips-tag-item"
                          [style.color]="fontColor"
                          [style.background-color]="backgroundColor">
                        {{ fullTagName }}
                    </span>
                </legend>
                <div class="cmdb-tag-label">
                    <aa-input-text2 name="category"
                                    label="{{ 'CMDB.TAGS.CREATE.CATEGORY' | translate}}"
                                    required
                                    [formControlName]="CategoryField">
                    </aa-input-text2>
                    <aa-input-text2 name="label"
                                    label="{{ 'CMDB.TAGS.CREATE.LABEL' | translate}}"
                                    required
                                    [formControlName]="LabelField">
                    </aa-input-text2>
                </div>
                <aa-input-text2 name="label"
                                label="{{ 'CMDB.TAGS.LIST.DESCRIPTION' | translate}}"
                                [formControlName]="DescriptionField">
                </aa-input-text2>
            </fieldset>
        </form>
    </div>
    <div class="popin-content-footer">
        <aa-btn-action-primary [btnText]="'BUTTON.SAVE' | translate"
                               [cta]="onSave">
        </aa-btn-action-primary>
    </div>
</aa-popin-v3>
